import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { BarRatingModule } from "ngx-bar-rating";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { OwlModule } from "ngx-owl-carousel";
import { SwiperModule } from "swiper/angular/";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import {
    AgmCoreModule,
    LAZY_MAPS_API_CONFIG,
    LazyMapsAPILoaderConfigLiteral,
} from "@agm/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { AddEditPhoneAndVerifyComponent } from "../Pages/Checkout/add-edit-phone-and-verify/add-edit-phone-and-verify.component";
import { CheckoutAcceptDialog } from "../Pages/Checkout/checkout-accept-dialog/checkout-accept-dialog.component";
import { SafePipe } from "../safe.pipe";
import { sanitizeHtmlPipe } from "../safehtml.pipe";
import { AboutInfoComponent } from "./AboutInfo/AboutInfo.component";
import { AddToCardButtonComponent } from "./AddToCardButton/AddToCardButton.component";
import { BannersComponent } from "./banners/banners.component";
import { CTAGroupComponent } from "./CallToAction/CTA-Group/CTA-Group.component";
import { CTASingleBannerComponent } from "./CallToAction/CTA-SingleBanner/CTA-SingleBanner.component";
import { CTATwoComponent } from "./CallToAction/CTA-Two/CTA-Two.component";
import { CategoriesComponent } from "./categories/categories.component";
import { CollectionGalleryComponent } from "./CollectionGallery/CollectionGallery.component";
import { ConfirmationPopupComponent } from "./ConfirmationPopup/ConfirmationPopup.component";
import { ControlAddToCartComponent } from "./control-add-to-cart/control-add-to-cart.component";
import { CurrencyDropDownComponent } from "./CurrencyDropDown/CurrencyDropDown.component";
import { DealOfTheDayComponent } from "./DealOfTheDay/DealOfTheDay.component";
import { FocusDirective } from "./Directives/focus.directive";
import { DownloadAppSectionComponent } from "./DownloadAppSection/DownloadAppSection.component";
import { FeaturesComponent } from "./Features/Features.component";
import { HeaderCartComponent } from "./HeaderCart/HeaderCart.component";
import { HeaderUserProfileDropdownComponent } from "./HeaderUserProfileDropdown/HeaderUserProfileDropdown.component";
import { ImgZoomComponent } from "./ImgZoom/ImgZoom.component";
import { LanguageDropDownComponent } from "./LanguageDropDown/LanguageDropDown.component";
import { LighteningDealsComponent } from "./LighteningDeals/LighteningDeals.component";
import { LoginIconComponent } from "./login-icon/login-icon.component";
import { MapComponent } from "./Map/Map.component";
import { MissionVisionComponent } from "./MissionVision/MissionVision.component";
import { NewProductsCardComponent } from "./NewProductsCard/NewProductsCard.component";
import { NotificationListMenuComponent } from "./notification-list-menu/notification-list-menu.component";
import { PageTitleComponent } from "./PageTitle/PageTitle.component";
import { ProductCardComponent } from "./ProductCard/ProductCard.component";
import { ProductCategoryCardComponent } from "./ProductCategoryCard/ProductCategoryCard.component";
import { RatingComponent } from "./Rating/Rating.component";
import { ReviewPopupComponent } from "./ReviewPopup/ReviewPopup.component";
import { HomePageTwoSliderComponent } from "./Slider/HomePageTwoSlider/HomePageTwoSlider.component";
import { SubscribeOneComponent } from "./Subscribe/SubscribeOne/SubscribeOne.component";
import { SubscribeTwoComponent } from "./Subscribe/SubscribeTwo/SubscribeTwo.component";
import { TeamComponent } from "./Team/Team.component";
import { TestimonialComponent } from "./Testimonial/Testimonial.component";
import { TimerCountDownComponent } from "./TimerCountDown/TimerCountDown.component";
import { WishListComponent } from "./WishList/WishList.component";
import { CartStockValidationErrorsComponent } from "./cart-stock-validation-errors/cart-stock-validation-errors.component";
import { ImageUploaderComponent } from "./image-uploader/image-uploader.component";
import { SearchPipe } from "../pipe/search.pipe";
import { LoadingModule } from "./loading/loading.module";
import { StaticPagesService } from "../Services/static-pages.service";
import { UpdatedProductCardComponent } from "./updated-product-card/updated-product-card.component";
import { BrandsServiceService } from "../Services/brands-service.service";
import { BrandImagesComponent } from "./brand-images/brand-images.component";
import { BrandsCarouselComponent } from "./brands-carousel/brands-carousel.component";
import { BrandsComponent } from "./brands/brands.component";
import { NgxPaginationModule } from "ngx-pagination";
import { BreadCrumbsModule } from "./components/bread-crumbs/bread-crumbs/bread-crumbs.module";
import { AllCategoriesComponent } from "./all-categories/all-categories.component";
import { VendorsComponent } from "./vendors/vendors.component";

import { CategoryViewComponent } from "./category-view/category-view.component";
import { SourceIconsModule } from "../source-icons/source-icons.module";
import { OrderRateComponent } from "./order-rate/order-rate.component";
import { HomeSectionsComponent } from "./home-sections/home-sections.component";
import { CeilPipe } from "../ceil.pipe";
import { ViewAdsPopupComponent } from './home-sections/view-ads-popup/view-ads-popup.component';
import { QuantityLimitDialogComponent } from './quantity-limit-dialog/quantity-limit-dialog.component';
// import { SourceIconsComponent } from "../source-icons/source-icons.component";

var initialApiKey = "";
/********** Custom option for ngx-translate ******/
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}
export function agmConfigFactory(
    configData: StaticPagesService,
    config: LazyMapsAPILoaderConfigLiteral
) {
    return () =>
        configData.getenvConfig().subscribe((res) => {
            if (res) {
                initialApiKey = res?.GOOGLE_MAP_API_KEY;
                config.apiKey = res?.GOOGLE_MAP_API_KEY;
                return res;
            }
        });
}

@NgModule({
    imports: [
        SourceIconsModule,
        CommonModule,
        SwiperModule,
        RouterModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatButtonModule,
        FlexLayoutModule,
        MatCardModule,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatExpansionModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatChipsModule,
        SweetAlert2Module,
        MatListModule,
        MatSidenavModule,
        MatTabsModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatSliderModule,
        MatRadioModule,
        MatDialogModule,
        MatGridListModule,
        BarRatingModule,
        AgmCoreModule.forRoot({
            apiKey: initialApiKey,
            libraries: ["places"],
        }),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgxImageZoomModule,
        OwlModule,
        LoadingModule,
        NgxPaginationModule,
        BreadCrumbsModule,
    ],
    declarations: [
        // SourceIconsComponent,
        FeaturesComponent,
        SubscribeOneComponent,
        DealOfTheDayComponent,
        RatingComponent,
        AddToCardButtonComponent,
        ReviewPopupComponent,
        HeaderCartComponent,
        CeilPipe,
        WishListComponent,
        ConfirmationPopupComponent,
        PageTitleComponent,
        TimerCountDownComponent,
        MapComponent,
        CurrencyDropDownComponent,
        LanguageDropDownComponent,
        TestimonialComponent,
        TeamComponent,
        MissionVisionComponent,
        AboutInfoComponent,
        ImgZoomComponent,
        ProductCardComponent,
        HeaderUserProfileDropdownComponent,
        LighteningDealsComponent,
        SubscribeTwoComponent,
        HomePageTwoSliderComponent,
        CTAGroupComponent,
        CTATwoComponent,
        CollectionGalleryComponent,
        ProductCategoryCardComponent,
        CTASingleBannerComponent,
        DownloadAppSectionComponent,
        NewProductsCardComponent,
        LoginIconComponent,
        AddEditPhoneAndVerifyComponent,
        BannersComponent,
        FocusDirective,
        NotificationListMenuComponent,
        sanitizeHtmlPipe,
        ControlAddToCartComponent,
        ImageUploaderComponent,
        SafePipe,
        CheckoutAcceptDialog,
        CategoriesComponent,
        CartStockValidationErrorsComponent,
        SearchPipe,
        UpdatedProductCardComponent,
        BrandImagesComponent,
        BrandsCarouselComponent,
        BrandsComponent,
        AllCategoriesComponent,
        CategoryViewComponent,
        OrderRateComponent,
        HomeSectionsComponent,
        VendorsComponent,
        ViewAdsPopupComponent,
        QuantityLimitDialogComponent,
    ],
    exports: [
        // SourceIconsComponent,
        LoadingModule,

        SwiperModule,
        CommonModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatButtonModule,
        FlexLayoutModule,
        MatCardModule,
        SweetAlert2Module,
        MatMenuModule,
        MatToolbarModule,
        MatIconModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatExpansionModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatChipsModule,
        MatListModule,
        MatSidenavModule,
        MatTabsModule,
        MatProgressBarModule,
        MatCheckboxModule,
        MatSliderModule,
        MatRadioModule,
        MatDialogModule,
        MatGridListModule,
        TranslateModule,
        FeaturesComponent,
        SubscribeOneComponent,
        ImageUploaderComponent,
        DealOfTheDayComponent,
        RatingComponent,
        AddToCardButtonComponent,
        HeaderCartComponent,
        CeilPipe,
        WishListComponent,
        PageTitleComponent,
        TimerCountDownComponent,
        MapComponent,
        CurrencyDropDownComponent,
        LanguageDropDownComponent,
        TestimonialComponent,
        TeamComponent,
        MissionVisionComponent,
        AboutInfoComponent,
        ImgZoomComponent,
        ProductCardComponent,
        HeaderUserProfileDropdownComponent,
        LighteningDealsComponent,
        SubscribeTwoComponent,
        HomePageTwoSliderComponent,
        CTAGroupComponent,
        CTATwoComponent,
        CollectionGalleryComponent,
        ProductCategoryCardComponent,
        CTASingleBannerComponent,
        DownloadAppSectionComponent,
        NewProductsCardComponent,
        LoginIconComponent,
        AddEditPhoneAndVerifyComponent,
        BannersComponent,
        FocusDirective,
        NotificationListMenuComponent,
        sanitizeHtmlPipe,
        ControlAddToCartComponent,
        SafePipe,
        CheckoutAcceptDialog,
        CartStockValidationErrorsComponent,
        AgmCoreModule,
        SearchPipe,
        UpdatedProductCardComponent,
        BrandImagesComponent,
        BrandsCarouselComponent,
        CategoriesComponent,
        HomeSectionsComponent,
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: agmConfigFactory,
            deps: [StaticPagesService, LAZY_MAPS_API_CONFIG],
            multi: true,
        },
        BrandsServiceService,
    ],
    entryComponents: [
        ReviewPopupComponent,
        ConfirmationPopupComponent,
        AddEditPhoneAndVerifyComponent,
        CheckoutAcceptDialog,
    ],
})
export class GlobalModule {}
